module.exports = __webpack_public_path__ + "img/emo_08.60b49521.png";